/**
 * Identificador interno de abono: AAABNNNN
 * Ej. 26AB0001. Se reinicia cada año natural.
 * Los abonos antiguos no tienen este campo.
 */

export function formatCodigoAbono(year, seq) {
  return `${String(year).slice(-2)}AB${String(seq).padStart(4, "0")}`;
}

export async function siguienteCodigoAbono(db) {
  const year = new Date().getFullYear();
  const counterRef = db.collection("counters").doc(String(year));

  const seq = await db.runTransaction((transaction) => {
    return transaction.get(counterRef).then((snap) => {
      const lastSeq =
        snap.exists && Number(snap.data().lastSeq)
          ? Number(snap.data().lastSeq)
          : 0;
      const next = lastSeq + 1;
      transaction.set(counterRef, { lastSeq: next, year });
      return next;
    });
  });

  return formatCodigoAbono(year, seq);
}

/** Para correos: el PHP usa "factura" como referencia visible. */
export function etiquetaFacturaEmail(abono) {
  const factura = (abono && abono.factura) || "";
  if (abono && abono.codigoAbono) {
    return `${abono.codigoAbono} · ${factura}`;
  }
  return factura;
}
